(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-collapsible"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  const items = document.querySelectorAll(".custom-faq-item");

  items.forEach((item) => {
    const question = item.querySelector(".custom-faq-question");
    const answer = item.querySelector(".custom-faq-answer");
    const icon = item.querySelector(".custom-faq-toggle-icon");

    question.addEventListener("click", function () {
      const isOpen = answer.classList.contains("active");

      // Optional: Close all other items if you want accordion behavior
      items.forEach((el) => {
        el.querySelector(".custom-faq-answer").classList.remove("active");
        el.querySelector(".custom-faq-toggle-icon").textContent = "+";
      });

      if (!isOpen) {
        answer.classList.add("active");
        icon.textContent = "–";
      } else {
        answer.classList.remove("active");
        icon.textContent = "+";
      }
    });
  });
});

  } catch(e) { console.error(e); }
})();
})();
